import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.pendingInvitations;

const getPendingInvitations = createSelector(
  getData,
  pendingInvitations => pendingInvitations
);

export default getPendingInvitations;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getPendingInvitations.js